module.exports = __webpack_public_path__ + "static/img/product1.4cf9bdf3.png";